import AxiosRepository from "./axios/AxiosRepository";
export { default as history } from './history';
export default AxiosRepository;
//# sourceMappingURL=index.js.map